import { render, staticRenderFns } from "./SrMessage.vue?vue&type=template&id=43d2dc1f&scoped=true&"
import script from "./SrMessage.vue?vue&type=script&lang=js&"
export * from "./SrMessage.vue?vue&type=script&lang=js&"
import style0 from "./SrMessage.vue?vue&type=style&index=0&id=43d2dc1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2dc1f",
  null
  
)

export default component.exports